module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a class="dropdown-toggle" href="#" role="button" aria-haspopup="true" aria-expanded="false" data-toggle="dropdown">\n    '+
((__t=( model.labelText ))==null?'':__t)+
'\n    <span class="caret"></span>\n</a>\n<ul class="tl-dropdown-menu-container dropdown-menu"></ul>';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/vendor/treeline-shared-components/tabs/tabs-dropdown.html
 ** module id = 283
 ** module chunks = 1 2 3 7 32 39 46
 **/